export default "__VITE_ASSET__Bq7UC304__"